import { createSelector } from "reselect";

const startedSelector = (state) => state.timer.examStarted;

export const examStartedSelector = createSelector(
    startedSelector,
    (examStarted) => examStarted
  );